<template>
    <span>
        <i v-tooltip="{
                      content: tipText,
                      show: showTip,
                      trigger: 'manual',
                      placement: 'top',
                    }"
           class="far fa-clone"
           @click="doCopy()"
           @mouseover="showTip = true"
           @mouseleave="closeTip" />
    </span>
</template>

<script>

  export default {
    name: "CopyLinkToBuffer",
    data() {
      return {
        tipText: 'Скопировать ссылку',
        showTip: false
      }
    },
    props: {
      link: {
        type: String,
        required: true
      }
    },
    methods: {
      closeTip() {
        this.showTip = false
        setTimeout(() => {
          this.tipText = 'Скопировать ссылку'
        }, 100)
      },
      doCopy() {
        // eslint-disable-next-line no-unused-vars
        this.$copyText(this.link).then(e => {
          this.tipText = 'Скопировано'
          // window.console.log(e)
          // eslint-disable-next-line no-unused-vars
        }, e => {
          this.tipText = 'Ошибка'
          // window.console.log(e)
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
    .far:hover
        color: #5CA5D4
    .far:active
        color: #3956d4
</style>
